export const ADMIN_PORTAL_API_BASE_URL = process.env.REACT_APP_BASE_URL;
export const ADMIN_PORTAL_AUTH_TOKEN = process.env.REACT_APP_ADMIN_PORTAL_AUTHTOKEN;
